// extracted by mini-css-extract-plugin
export default {"content-switcher":"content-switcher_content-switcher__OCGsA"};